import { render, staticRenderFns } from "./index.vue?vue&type=template&id=21affc14&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21affc14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21affc14')) {
      api.createRecord('21affc14', component.options)
    } else {
      api.reload('21affc14', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=21affc14&scoped=true&", function () {
      api.rerender('21affc14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userManage/configFileList/index.vue"
export default component.exports